import LazyLoad from 'vanilla-lazyload';
export default (() => {
    console.log('UNTUCKit : Module : LazyImages : loaded');
    // set to global namespace for use in non-es-module code
    const ll = window.lazyImg = new LazyLoad({
        elements_selector: "img:not(.shogun-image):not(.boost-pfs-filter-product-item-main-image):not(.boost-pfs-filter-product-item-flip-image), picture, .lazy-background, .lazy-video" // shogun, boost use separate lazy loading
    });
    const update = (delay = 0) => {
        console.log('UNTUCKit : LazyImages : update', delay);
        setTimeout(() => {
            ll.update();
        }, delay);
    };
    return {
        update
    };
})();
